export { getOptimalTextShade } from './colors';
export { createComponent } from './create-component';
//# sourceMappingURL=index.js.map